import { Reducer } from 'redux';
import { DashSlaState, dashSlaTypes } from './types';

const INITIAL_STATE: DashSlaState = {
  data: [],
  loading: false,
  error: false,
};

const reducer: Reducer<DashSlaState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case dashSlaTypes.LOAD_RESUMO_ATENDIMENTO_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case dashSlaTypes.RESUMO_ATENDIMENTO_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data,
      };
    case dashSlaTypes.RESUMO_ATENDIMENTO_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    default:
      return state;
  }
};

export default reducer;
